module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-head"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "toc_fm"
  }, [_c('p', {
    staticClass: "toc_fm"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_cvi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "d08649ec90568-d1e215"
    }
  }), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e215"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_alb"
    }
  }, [_vm._v("A Selection of Recent Titles by Graham Masterton Available From Severn House")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "d08649ec90568-d1e281"
    }
  }), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e281"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_tp"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "d5984bf778bcc-d1e32"
    }
  }), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "d5984bf778bcc-d1e32"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_cop"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "d08649ec90568-d1e360"
    }
  }), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e360"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_epi"
    }
  }, [_vm._v("Epigraph")])])]), _c('div', {
    staticClass: "toc_body"
  }, [_c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e373"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e373"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap001"
    }
  }, [_vm._v("Chapter One")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e544"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e544"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap002"
    }
  }, [_vm._v("Chapter Two")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e821"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e821"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap003"
    }
  }, [_vm._v("Chapter Three")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e1085"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e1085"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap004"
    }
  }, [_vm._v("Chapter Four")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e1290"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e1290"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e1713"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e1713"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e2028"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e2028"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e2365"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e2365"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e2562"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e2562"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e2875"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e2875"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e3164"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e3164"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e3432"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e3432"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e3837"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e3837"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e4240"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e4240"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e4518"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e4518"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e4898"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e4898"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e5227"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e5227"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seventeen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e5593"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e5593"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eighteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e5812"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e5812"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nineteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e6129"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e6129"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e6439"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e6439"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-One")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e6773"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e6773"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Two")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e6999"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e6999"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Three")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e7312"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e7312"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Four")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e7666"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e7666"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Five")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e8137"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e8137"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Six")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e8394"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e8394"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Seven")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e8708"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "d08649ec90568-d1e8708"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106588_epub_chap028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Eight")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3acf28db","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781780106588_epub_itoc.vue
// module id = 60
// module chunks = 0